const http = uni.$u.http

let data = [];
data.length

/**
 * 登录
 * @param data
 * @returns {HttpPromise<any>}
 */
export const loginPda = (data ={}) => http.post('/app/car/login',data)

/**
 * 车辆备案
 * @param data
 * @returns {HttpPromise<any>}
 */
export const vehicle = (data ={}) => http.post('/car/wx/addCar',data)
export const auditCar = (data ={}) => http.post('/car/wx/auditCar',data)


/**
 * 公司分页列表
 * @param data
 * @returns {HttpPromise<any>}
 */
export const getApplyCarList = (data ={}) => http.get('car/wx/applyCarList',{params: {...data}});
export const getAuditCarList = (data ={}) => http.get('car/wx/auditCarList',{params: {...data}});
export const getDeptList = (data ={}) => http.get('car/wx/getDept',{params: {...data}});

/**
 * 公司分页列表
 * @param data
 * @returns {HttpPromise<any>}
 */
export const deptList = (data ={}) => http.get('car/wx/treeselect',{params: {...data}});

/**
 * 字典字查询
 * @param dictType
 * @returns {HttpPromise<any>}
 */
export const dictType = (dictType) => http.get('car/wx/type/'+dictType);


/**
 * 公司分页列表
 * @param data
 * @returns {HttpPromise<any>}
 */
export const menuList = (data ={}) => http.get('car/wx/getRouters',{params: {...data}});
export const getSessionKey = (data ={}) => http.get('car/wx/getOpenId',{params: {...data}});


export const getOssToken = () => http.get('app/car/getOssToken')
